import styled from 'styled-components'

export const Container = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 20px;
  padding: 0px 5px;

  border-radius: 6px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    height: 16px;
  }
`

export const Label = styled.label`
  margin: auto;

  color: var(--persistent-white, #fff);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
`
